import { requestConfig } from "../config.js";

/**
 * Получить перечень договоров у контрагента на адресе
 *
 * @param {String} apiKey
 */
export async function apiFetchContractList(apiKey) {
  const response = await requestConfig.get("/api/v0/master/mobile_connect/get_contracts/", {
    params: {
      key: apiKey,
    },
  });

  return response.data?.detail;
}
